import { ReactNode } from 'react';
import { AdminTableProvider } from './AdminTable';

/**
 * Wrapper for admin pages that display data listed in AdminTable component. Provides basic template as well as AdminTableContext provider
 */
export const AdminListPageWrapper = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  return (
    <AdminTableProvider>
      <div className='flex flex-col justify-center gap-6'>
        <h1 className='text-center font-bold'>{title}</h1>
        <div className='w-full flex flex-col gap-4'>{children}</div>
      </div>
    </AdminTableProvider>
  );
};
